import React from 'react';
import MultiRangeSlider from 'multi-range-slider-react';

const PRODUCT_CATEGORIES = {
  all: 'All Products',
  flood: 'Flood Lights',
  street: 'Street Lights',
  home: 'Home Solutions',
  inverter: 'Inverter Systems',
  irrigation: 'Irrigation Systems'
};

export default function Filter({ 
  selectedCategory, 
  setSelectedCategory,
  searchQuery,
  setSearchQuery,
  priceRange,
  setPriceRange
}) {
  // Ensure we have valid price range values
  const safeMinValue = priceRange?.min ?? 0;
  const safeMaxValue = priceRange?.max ?? 150000;

  const handleCategoryChange = (category) => {
    if (setSelectedCategory) {
      setSelectedCategory(category);
    }
  };

  const handleInput = (e) => {
    if (setPriceRange && e?.minValue !== undefined && e?.maxValue !== undefined) {
      setPriceRange({
        min: e.minValue,
        max: e.maxValue
      });
    }
  };

  const formatPrice = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="cs_shop_sidebar">
      <div className="cs_shop_sidebar_widget">
        <form action="#" className="cs_shop_search" onSubmit={e => e.preventDefault()}>
          <input
            className="cs_shop_search_input"
            type="text"
            placeholder="Search Products..."
            value={searchQuery || ''}
            onChange={(e) => setSearchQuery?.(e.target.value)}
          />
          <button className="cs_shop_search_btn" type="button">
            <svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6939 10.3222C11.5282 10.1562 11.3033 10.0629 11.0688 10.0629H10.8189C10.7506 10.0629 10.6849 10.0364 10.6357 9.98894C10.535 9.89181 10.5281 9.73333 10.6148 9.62352C11.416 8.60899 11.8925 7.33012 11.8925 5.94625C11.8925 2.66209 9.23042 0 5.94625 0C2.66209 0 0 2.66209 0 5.94625C0 9.23042 2.66209 11.8925 5.94625 11.8925C7.33012 11.8925 8.60899 11.416 9.62352 10.6148C9.73333 10.5281 9.89181 10.535 9.98894 10.6357C10.0364 10.6849 10.0629 10.7506 10.0629 10.8189V11.0688C10.0629 11.3033 10.1562 11.5282 10.3222 11.6939L13.9547 15.3191C14.3316 15.6953 14.942 15.695 15.3185 15.3185C15.695 14.942 15.6953 14.3316 15.3191 13.9547L11.6939 10.3222ZM5.94625 10.0629C3.66838 10.0629 1.82962 8.22413 1.82962 5.94625C1.82962 3.66838 3.66838 1.82962 5.94625 1.82962C8.22413 1.82962 10.0629 3.66838 10.0629 5.94625C10.0629 8.22413 8.22413 10.0629 5.94625 10.0629Z"
                fill="#4F4747"
              />
            </svg>
          </button>
        </form>
      </div>

      <div className="cs_shop_sidebar_widget">
        <h3 className="cs_shop_sidebar_widget_title">Categories</h3>
        <ul className="cs_shop_sidebar_category_list">
          {Object.entries(PRODUCT_CATEGORIES).map(([value, label]) => (
            <li key={value}>
              <div className="cs_checkbox_group">
                <input 
                  type="radio" 
                  id={value}
                  name="category"
                  checked={selectedCategory === value}
                  onChange={() => handleCategoryChange(value)}
                />
                <label htmlFor={value}>{label}</label>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="cs_shop_sidebar_widget">
        <h3 className="cs_shop_sidebar_widget_title">Price Filter</h3>
        <MultiRangeSlider
          min={0}
          max={150000}
          step={1000}
          minValue={safeMinValue}
          maxValue={safeMaxValue}
          ruler={false}
          label={false}
          onInput={handleInput}
          style={{
            border: 'none',
            boxShadow: 'none',
            padding: '15px 10px'
          }}
        />
        <div className="cs_multirange_price">
          Price: KSH {formatPrice(safeMinValue)} - KSH {formatPrice(safeMaxValue)}
        </div>
      </div>
    </div>
  );
}

